export const SHORT_SEARCH_DELAY = 500;
export const LONG_SEARCH_DELAY = 2000;

/**
 * Creates a promise that resolves after the specified delay in milliseconds.
 * Useful for introducing delays, especially for waiting on elastic search indexing.
 *
 * @param ms - The delay in milliseconds
 * @returns A promise that resolves after the delay
 *
 * @example
 * await delay(SHORT_SEARCH_DELAY);
 */
export function delay(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
